import { IndividualApplicationParameters } from '@platform/client/schemas';
import { FormsCheckBox, InlineFormInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Jonathan-Munyany.svg';

type FormValues = {
  currentEmployer: string;
  hasWorkedAtSap: boolean;
};

export const CurrentEmploymentSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<IndividualApplicationParameters>();

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      currentEmployer: getApplicationDataByKey('currentEmployer'),
      hasWorkedAtSap: !!getApplicationDataByKey('hasWorkedAtSap'),
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      currentEmployer: data.currentEmployer,
      hasWorkedAtSap: data.hasWorkedAtSap,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      currentEmployer: watch('currentEmployer'),
      hasWorkedAtSap: watch('hasWorkedAtSap'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title='Where do you currently work?'
        description="This helps us understand your current professional context - no matter what stage you're in."
      >
        <InlineFormInput
          label={"Current employer (enter 'unemployed' or 'self-employed' if applicable)"}
          placeholder='Enter your company name'
          register={() =>
            register('currentEmployer', {
              required: 'Enter your company name or employment status to continue',
            })
          }
          errors={errors.currentEmployer}
        />
        <div className='flex flex-row items-start justify-start'>
          <FormsCheckBox
            name='hasWorkedAtSap'
            size='md'
            description='I previously worked at SAP'
            control={control}
          />
        </div>
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
